import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

function Celda(props) {
   const {valor, nombreCampo, titulo, children, ...other} = props;

   return (
      <Grid item {...other}>
         <Typography
            variant="h6"
            className="MuiTableHead-root"
            display="inline"
         >{`${titulo}:`}</Typography>{' '}
         <Typography variant="body1" display="inline">
            {children}
         </Typography>
      </Grid>
   );
}

export default Celda;
